<template>
  <div class="nft-item">
    <div
      :style="{ background: isCollection ? 'none' : '#fff' }"
      class="nft-core"
    >
      <div
        @click="detailJump(item.detail_jump)"
        :class="['nft-poster', isCollection ? 'nft-poster-collection' : '']"
        :style="{
          paddingBottom: (imgInfo.height / imgInfo.width) * 100 + '%',
        }"
      >
        <VImg
          :src="item.image"
          :width="imgInfo.width"
          :height="imgInfo.height"
          rule="1c"
        ></VImg>
      </div>
      <div
        :style="{ padding: isCollection ? '6px 0' : null }"
        :class="['nft-info', isCollection ? 'nft-info-collection' : '']"
      >
        <!-- 全部 -->
        <template v-if="!isCollection">
          <div class="nft-name-txt">
            {{ item.item_name }} {{ item.serial_number }}
          </div>
          <div class="user-info">
            <div>
              <img
                class="user-avatar"
                :src="
                  item.avatar.includes('https')
                    ? item.avatar
                    : item.avatar.replace('http', 'https')
                "
                alt=""
              />
            </div>
            <div class="user-name">{{ item.username }}</div>
          </div>
        </template>
        <!-- 我的收藏、TA的收藏 -->
        <template v-else>
          <div v-if="isCollection" class="nft-name-txt">
            #{{ item.token_id }}
          </div>
          <div class="nft-like">
            <img
              v-if="!likeState"
              @click="changeLikeState(1)"
              src="../assets/like.svg"
              class="nft-like-icon"
            />
            <img
              v-else
              @click="changeLikeState(2)"
              src="../assets/liked.svg"
              class="nft-like-icon"
            />
            <div class="nft-like-count">{{ likeNumber }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { VImg } from "@bilibili/sakura";
import { biliBridge } from "@bilibili/js-bridge";
import { updateLikeState } from "../store/api";

export default {
  name: "NftItem",
  components: {
    VImg,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    imgInfo: {
      type: Object,
      required: true,
    },
    active_id: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      likeNumber: this.item.like_number || 0,
      likeState: !!this.item.like_status,
      timer: null,
    };
  },
  // filters: {
  //   ellipsis(value) {
  //     let len = value.length;
  //     if(!value) return ""
  //     if(value.length === 2) {
  //       return value.substring(0,1) + '*'
  //     } else {
  //       return value.substring(0,1) + '***' + value.substring(len - 1, len)
  //     }
  //   }
  // },
  methods: {
    detailJump(url) {
      biliBridge.callNative({
        method: "ability.openScheme",
        data: {
          url,
        },
      });
    },
    async changeLikeState(action) {
      if (this.timer) return;
      this.timer = setTimeout(() => {
        this.timer = null;
      }, 1000);
      try {
        const { code, data } = await updateLikeState({
          action,
          nft_id: this.item.nft_id,
        });
        if (code === 0 && data?.success === 1) {
          action === 1 ? (this.likeNumber += 1) : (this.likeNumber -= 1);
          this.likeState = action === 1;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    isCollection() {
      return [1, 2].includes(this.active_id);
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
// 测试染色
.nft-item {
  width: 50%;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;

  .nft-core {
    background-color: #fff;
    overflow: hidden;
    height: 100%;
    border-radius: 16px;

    .nft-poster {
      position: relative;
      height: 0;
      width: 100%;
      padding-bottom: 100%;
      background-color: #fff;

      .v-img {
        position: absolute;
        top: 0;
        left: 0;
      }
      &.nft-poster-collection {
        border-radius: 16px;
        overflow: hidden;
      }
    }

    .nft-info {
      // height: 56px;
      padding: 8px;
      color: #18191c;
      font-size: 14px;
      line-height: 18px;

      .nft-name-txt {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .nft-token-txt {
        margin-top: 4px;
        font-size: 11px;
        color: #61666d;
      }
      &.nft-info-collection {
        display: flex;
        justify-content: space-between;
        .nft-like {
          display: flex;
          .nft-like-icon {
            width: 16px;
            height: 16px;
          }
          .nft-like-count {
            font-size: 12px;
            color: #9499a0;
            margin-left: 4px;
          }
        }
      }
    }

    .user-info {
      display: flex;
      align-items: center;

      .user-avatar {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        margin: 8px 4px 8px 0;
      }

      .user-name {
        color: #61666d;
        font-size: 11px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
